import {
  CIT_RATE,
  GCT_THRESHOLD_JMD,
  filterByYear,
  formatJMD,
  rollingTwelveMonthTotal,
  sumJmd,
} from '../../lib/finances';

export default function TaxEstimate({ expenses, income, year }) {
  const yearIncome = filterByYear(income, year);
  const yearExpenses = filterByYear(expenses, year);

  const totalIncome = sumJmd(yearIncome);
  const totalExpenses = sumJmd(yearExpenses);
  const netChargeableIncome = totalIncome - totalExpenses;
  const estimatedCIT = netChargeableIncome > 0 ? netChargeableIncome * CIT_RATE : 0;

  const rollingRevenue = rollingTwelveMonthTotal(income);
  const gctRegistrationNeeded = rollingRevenue >= GCT_THRESHOLD_JMD;

  return (
    <div className="tax-estimate">
      <div className="tax-estimate-cards">
        <div className="tax-estimate-card">
          <span className="tax-estimate-label">Total income ({year})</span>
          <span className="tax-estimate-value">{formatJMD(totalIncome)}</span>
        </div>
        <div className="tax-estimate-card">
          <span className="tax-estimate-label">Total allowable expenses ({year})</span>
          <span className="tax-estimate-value">{formatJMD(totalExpenses)}</span>
        </div>
        <div className="tax-estimate-card">
          <span className="tax-estimate-label">Net chargeable income</span>
          <span className="tax-estimate-value">{formatJMD(netChargeableIncome)}</span>
        </div>
        <div className="tax-estimate-card tax-estimate-highlight">
          <span className="tax-estimate-label">Estimated CIT (25%)</span>
          <span className="tax-estimate-value">{formatJMD(estimatedCIT)}</span>
        </div>
      </div>

      {netChargeableIncome <= 0 && (
        <p className="tax-estimate-note">
          Net chargeable income is zero or negative for {year}, so no Corporate Income Tax is
          estimated to be owed.
        </p>
      )}

      <div className="tax-estimate-gct">
        <h3>GCT registration</h3>
        <p>
          Rolling 12-month revenue: <strong>{formatJMD(rollingRevenue)}</strong> — threshold:{' '}
          <strong>{formatJMD(GCT_THRESHOLD_JMD)}</strong>
        </p>
        <p className={gctRegistrationNeeded ? 'tax-estimate-warning' : 'tax-estimate-ok'}>
          {gctRegistrationNeeded
            ? 'Rolling turnover is at or above the threshold — GCT registration is required.'
            : 'Below the threshold — GCT registration is optional for now.'}
        </p>
      </div>

      <p className="tax-estimate-disclaimer">
        This is a working estimate, not tax advice. Confirm your actual position with a licensed
        Jamaican accountant before filing or paying TAJ.
      </p>
    </div>
  );
}
